export const environment = {
  production: false,
  isMockEnabled: false, // You have to switch this, when your real back-end is done
  authTokenKey: "lemaTokenKey",
  ApiURL: "https://api-dev.lema.dk/api",
  AppName: "LEMA",
  appVersion: require("../../package.json").version,
};
